<!-- Loading bar -->
<davesa-loading-bar></davesa-loading-bar>


<!-- Alert Banner -->
<!-- <davesa-alert-banner /> -->


<!-- Navigation -->
<davesa-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigation.default" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <!-- Navigation header hook -->
    <ng-container davesaVerticalNavigationContentHeader>
        <div class="flex w-full items-center p-4 pl-6">
            <!-- Logo -->
            <a [routerLink]="'/'">

                <div class="flex items-center justify-center">
                    <img class="w-8" src="images/logo/logo.svg" />
                    <span class="m-1 text-2xl text-gray-400">DAVESA</span>
                </div>
            </a>

            <!-- Components -->
            <div class="ml-auto flex items-center">
                <notifications></notifications>
                <user-menu></user-menu>
            </div>
        </div>
        <!-- User -->
        <login-user [showAvatar]="true" [showVertical]="true"></login-user>

    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container davesaVerticalNavigationContentFooter>
        <div class="mb-4 mt-2 flex h-16 flex-0 items-center justify-center pl-2 pr-6 opacity-12">
            <img class="max-w-36" src="images/logo/logo-text-on-dark.svg" />
        </div>
    </ng-container>
</davesa-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden">
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <!-- <languages></languages> -->
            <!-- <messages></messages> -->
            <!-- <settings></settings> -->
            @if (showClinicNow) {
                <clinic-now #clinicNow="clinicNow"></clinic-now>
            }
            <support-links></support-links>
            <davesa-fullscreen class="hidden md:block"></davesa-fullscreen>

        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- Password Expiry Banner -->
        <password-expiry-banner></password-expiry-banner>
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
        <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Davesa &copy; {{currentYear}}</span>
    </div>-->
</div>